/* global RedfastEnabled */
import { Redfast } from '@foxcorp/cpe-commerce-web';
import { isStaticRender } from 'helpers/ContentHelper';

const initializeRedfast = () => {
  const { evergent } = window.ExternalConfig;
  if (!RedfastEnabled || !evergent || isStaticRender()) return;

  Redfast.createActions({
    apiUrl: evergent.api,
    apiKey: evergent.apiKey,
  });
};

export default initializeRedfast;
